import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3>Advanced Cloudlink Technologies Inc</h3>
            <p>
              Delivering high-quality, client-centric IT solutions, cloud architectures, intelligent
              automation, and human capital consulting for modern enterprises.
            </p>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Cloud Migration & DevOps</Link></li>
              <li><Link to="/services">Enterprise Software</Link></li>
              <li><Link to="/services">Intelligent Automation</Link></li>
              <li><Link to="/services">IT Consulting & Staffing</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Get In Touch</h4>
            <div className="footer-contact-item">
              <span>📍</span>
              <span>520 Mary Ruth PL, Celina, TX 75009</span>
            </div>
            <div className="footer-contact-item">
              <span>✉️</span>
              <a href="mailto:hr@advancedcloudlinktechnologies.com">
                hr@advancedcloudlinktechnologies.com
              </a>
            </div>
            <div className="footer-contact-item">
              <span>📞</span>
              <a href="tel:2142265062">(214) 226-5062</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Advanced Cloudlink Technologies Inc. All rights reserved.</p>
          <p>Certified IT Consulting & Cloud Solutions Provider</p>
        </div>
      </div>
    </footer>
  );
}
